module.exports = __webpack_public_path__ + "img/ltkparties-3x.23430c8.jpg";